import axios from "axios";
import { triggerError } from "../utils/alerts.js";


const url = "/api/informationPages/";


class InformationPageService {

    // Get
    static getInformationPage(id, callback, errorCallback) {
        
        if (callback) {
            axios.get(`${url}${id}`).then(response => {
                callback(response.data);
            }).catch(error => {
                if (errorCallback) {
                    errorCallback(error);
                } else {
                    triggerError(error);
                }
            });
        } else {
            return new Promise(async resolve => {
                try {
                    const response = await axios.get(`${url}${id}`);
                    resolve(response.data);
                } catch (error) {
                    triggerError(error);
                    resolve(null);
                }
            });
        }
    }

    // Get all
    static getInformationPages(callback) {
        if (callback) {
            axios.get(url).then(response => {
                callback(response.data);
            }).catch(error => {
                triggerError(error);
            });
        } else {
            return new Promise(async resolve => {
                try {
                    const response = await axios.get(url);
                    resolve(response.data);
                } catch (error) {
                    triggerError(error);
                    resolve([]);
                }
            });
        }
    }

    // Get all by type
    static getInformationPagesByType(type, callback) {
        axios.get(`${url}getByType/${type}`).then(response => {
            callback(response.data);
        }).catch(error => {
            triggerError(error);
        });
    }

    // Post
    static insertInformationPage(informationPage, callback) {
        axios.post(url, informationPage).then(response => {
            callback(response.data);
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.isJoi) {
                callback({ errors: error.response.data.details });
            } else {
                triggerError(error);
            }
        });
    }

    // Put
    static updateInformationPage(informationPage, callback) {
        axios.put(`${url}${informationPage._id}`, informationPage).then(response => {
            response.data._id = informationPage._id;
            callback(response.data);
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.isJoi) {
                callback({ errors: error.response.data.details });
            } else {
                triggerError(error);
            }
        });
    }

    // Delete
    static deleteInformationPage(informationPageId, callback) {
        axios.delete(`${url}${informationPageId}`).then(response => {
            callback(response.data);
        }).catch(error => {
            triggerError(error);
        });
    }

}

export default InformationPageService;